// Styles for GenericTagPicker component
export const tagPickerStyles = {
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    tagPickerControl: {
        flexWrap: 'wrap',
        minHeight: 'auto'
    } as React.CSSProperties,
    tagPickerGroup: {
        flexWrap: 'wrap',
        maxWidth: '100%'
    } as React.CSSProperties,
    tagPickerInput: {
        minWidth: '200px',
        flexGrow: 1
    },
    defaultOption: {
        container: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px', // Reduced from 8px
            padding: '4px 0px', // Add compact padding
            minHeight: '32px' // Set compact height
        },
        avatar: {
            width: '20px', // Reduced from 24px
            height: '20px', // Reduced from 24px
            borderRadius: '50%',
            background: '#0078d4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '11px', // Reduced from 12px
            fontWeight: 'bold',
            flexShrink: 0 // Prevent avatar from shrinking
        } as React.CSSProperties,
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            gap: '1px', // Minimal gap between primary and secondary text
            overflow: 'hidden' // Prevent text overflow
        } as React.CSSProperties,
        primaryText: {
            fontWeight: '600', // Slightly less bold
            fontSize: '13px', // Reduced from 14px
            lineHeight: '16px', // Compact line height
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        secondaryText: {
            fontSize: '11px', // Reduced from 12px
            color: '#666',
            lineHeight: '14px', // Compact line height
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }
};
